<template>
  <div class="flip-card-game">
    <!-- 顶部金币显示 -->
    <div class="coin-display">金币：{{ coins }}</div>

    <!-- 游戏开始区域 -->
    <div v-if="!gameStarted" class="start-area">
      <p class="cost-text">200金币开始游戏</p>
      <button @click="startGame">开始游戏</button>
    </div>

    <!-- 翻牌区域 -->
    <div v-else class="card-area">
      <div class="timer">剩余时间：{{ timer }}s</div>
      <div class="card-grid">
        <div
          v-for="(card, index) in displayCards"
          :key="index"
          class="card"
          :class="{ flipped: card.flipped || card.matched }"
          @click="flipCard(index)"
        >
          <div class="card-front">?</div>
          <div class="card-back">
            <img :src="card.icon" />
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗提示 -->
    <div v-if="popupText" class="popup">{{ popupText }}</div>
  </div>
</template>

<script>
export default {
  name: 'FlipCardGame',
  data() {
    return {
      coins: 0,
      gameStarted: false,
      timer: 60,
      popupText: '',
      cardData: [
        { id: 1, icon: 'https://joygma.online/images/pokemon/icons/bulbasaur.png' },
        { id: 10, icon: 'https://joygma.online/images/pokemon/icons/caterpie.png' },
        { id: 2, icon: 'https://joygma.online/images/pokemon/icons/ivysaur.png' },
        { id: 3, icon: 'https://joygma.online/images/pokemon/icons/venusaur.png' },
        { id: 4, icon: 'https://joygma.online/images/pokemon/icons/charmander.png' },
        { id: 5, icon: 'https://joygma.online/images/pokemon/icons/charmeleon.png' },
      ],
      displayCards: [],
      flippedCards: [],
      matchedCount: 0,
      timerInterval: null,
    };
  },
  mounted() {
    this.fetchCoins();
  },
  methods: {
    async fetchCoins() {
      const userId = this.$getUserId();
      const res = await this.$axios.get(`/coin/balance/${userId}`);
      this.coins = res.data.coins;
    },
    async startGame() {
      const userId = this.$getUserId();

      try {
        const res = await this.$axios.post('/coin/decrease', { userId, amount: 200 });

        // 如果后端明确返回失败，提前退出
        if (res.data && res.data.success === false) {
          this.popup('金币不足');
          return;
        }
      } catch (err) {
        this.popup(err.response?.data?.error || '金币扣除失败');
        return;
      }

      this.gameStarted = true;
      this.prepareCards();
      this.timer = 60;
      this.matchedCount = 0;

      this.timerInterval = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          clearInterval(this.timerInterval);
          this.endGame(false);
        }
      }, 1000);
    },
    prepareCards() {
      const duplicated = [...this.cardData, ...this.cardData];
      const shuffled = duplicated.sort(() => 0.5 - Math.random());
      this.displayCards = shuffled.map(card => ({
        ...card,
        flipped: false,
        matched: false
      }));
      this.flippedCards = [];
    },
    flipCard(index) {
      const card = this.displayCards[index];
      if (card.flipped || card.matched || this.flippedCards.length >= 2) return;

      this.$set(this.displayCards[index], 'flipped', true);
      this.flippedCards.push({ ...card, index });

      if (this.flippedCards.length === 2) {
        const [first, second] = this.flippedCards;
        if (first.id === second.id) {
          this.$set(this.displayCards[first.index], 'matched', true);
          this.$set(this.displayCards[second.index], 'matched', true);
          this.matchedCount++;
          this.flippedCards = [];

          // 胜利条件：全部匹配
          if (this.matchedCount === this.cardData.length) {
            clearInterval(this.timerInterval);
            this.endGame(true);
          }
        } else {
          setTimeout(() => {
            this.$set(this.displayCards[first.index], 'flipped', false);
            this.$set(this.displayCards[second.index], 'flipped', false);
            this.flippedCards = [];
          }, 800);
        }
      }
    },
    async endGame(won) {
      this.gameStarted = false;
      if (won) {
        await this.$axios.post('/coin/increase', {
          userId: this.$getUserId(),
          amount: 300,
        });
        this.popup('胜利！获得300金币');
      } else {
        this.popup('失败！时间已到');
      }
      this.fetchCoins();
    },
    popup(msg) {
      this.popupText = msg;
      setTimeout(() => (this.popupText = ''), 2000);
    }
  }
};
</script>

<style scoped>
.flip-card-game {
  padding: 20px;
  background: #f9f9f9;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: sans-serif;
}

.coin-display {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #ffe58f;
  width: fit-content;
  box-shadow: 2px 2px 5px #ccc;
}

.start-area {
  text-align: center;
}

.start-area .cost-text {
  margin-bottom: 10px;
  font-size: 16px;
}

.start-area button {
  background-color: #4caf50;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  color: white;
  font-size: 18px;
  cursor: pointer;
}
.start-area button:hover {
  background-color: #388e3c;
}

.card-area {
  margin-top: 20px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 22%);
  gap: 10px;
  justify-content: center;
}

.card {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1.2;
  background: #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
  perspective: 800px;
}

.card.flipped .card-front {
  transform: rotateY(180deg);
}
.card.flipped .card-back {
  transform: rotateY(0deg);
}

.card-front,
.card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 10px;
  transition: transform 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-front {
  background: #fff;
  transform: rotateY(0deg);
  font-size: 30px;
}

.card-back {
  background: #fff;
  transform: rotateY(180deg);
}

.card-back img {
  width: 90%;
  height: 90%;
  object-fit: contain;
}

.timer {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center;
}

.popup {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  background: #000a;
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
}
</style>